import CreateCostCenterDialog from "@/components/companies/costcenter/CreateCostCenterDialog.vue";
import EditCostCenterDialog from "@/components/companies/costcenter/EditCostCenterDialog.vue";
import DeleteCostCenterDialog from "@/components/companies/costcenter/DeleteCostCenterDialog.vue";
import CreatePepDialog from "@/components/companies/pep/CreatePepCostCenterDialog.vue";
import SearchInput from "@/components/global/SearchInput.vue";

export default {
  name: "CostCenters",
  data: () => ({
    headers: [
      {
        text: "Nombre",
        value: "name",
        sortable: false,
        class: "primary--text",
      },
      {
        text: "Gerencia",
        value: "management_name",
        sortable: false,
        class: "primary--text",
      },
      {
        text: "Centro de Costo",
        value: "costCenter",
        sortable: false,
        class: "primary--text",
      },
      {
        text: "PEP",
        value: "pep_code",
        align: "center",
        sortable: false,
        class: "primary--text",
      },
      {
        text: "Estado",
        value: "active",
        align: "center",
        sortable: false,
        class: "primary--text",
      },
      {
        text: "Acciones",
        value: "actions",
        align: "right",
        sortable: false,
        class: "primary--text",
      },
    ],
    search: "",
    currentPage: 1,
    editedItem: {},
    deletedItem: {},
    companySelected: null,
    managementSelected: null,
    limit: 5,
    rowsPerPage: [{ value: 5 }, { value: 10 }, { value: 15 }, { value: 20 }, { value: 25 }, { value: 30 }]
  }),

  computed: {
    companies() {
      return this.$store.getters["companies/getCompaniesList"];
    },
    managements() {
      return this.$store.getters["managements/getManagementsList"];
    },
    costCenters() {
      return this.$store.getters["costCenters/getCostCenters"];
    },
    paginationPages() {
      return this.$store.getters["costCenters/getPaginationPages"];
    },
    isLoading() {
      return this.$store.state.costCenters.isLoading;
    },
  },

  created() {
    this.initialize();
  },

  methods: {
    initialize() {
      this.$store.dispatch("costCenters/getCostCenters", { page: 1,limit:this.limit });
      this.$store.dispatch("companies/getCompaniesList");
    },

    editItem(item) {
      this.editedItem = { ...item };
    },

    deleteItem(costCenter) {
      this.deletedItem = { ...costCenter };
    },

    listenPagination() {
      this.$store.dispatch("costCenters/getCostCenters", {
        page: this.currentPage,
        limit:this.limit,
        company_id: this.companySelected,
        management_id: this.managementSelected,
        search: this.search,
      });
      this.$store.dispatch("managements/updateCurrentPage", this.currentPage);
    },

    listenCompany() {
      this.currentPage = 1;
      this.managementSelected = null;
      this.search = "";
      this.$store.dispatch("costCenters/getCostCenters", {
        page: 1,
        limit:this.limit,
        company_id: this.companySelected,
      });
      this.$store.dispatch("managements/getManagementsList", {
        company_id: this.companySelected,
      });
    },

    listenManagement() {
      this.currentPage = 1;
      this.search = "";
      this.$store.dispatch("costCenters/getCostCenters", {
        page: 1,
        limit:this.limit,
        company_id: this.companySelected,
        management_id: this.managementSelected,
      });
    },

    resetFilter() {
      this.search = "";
      this.companySelected = null;
      this.managementSelected = null;
      this.currentPage = 1;
      this.limt = 5
    },
  },
  components: {
    CreateCostCenterDialog,
    EditCostCenterDialog,
    DeleteCostCenterDialog,
    CreatePepDialog,
    SearchInput,
  },
};
